module.exports = __webpack_public_path__ + "img/diamond.ae076df5.svg";